import axios from "axios";
import { adminRequest } from "services/FinanceService";

export const resolveReferralBase = (env = process.env) =>
  (
    env.REACT_APP_REFERRAL_API_BASE_URL ||
    env.REACT_APP_API_BASE_URL ||
    "https://merchantapex.fairsurepay.com"
  ).replace(/\/+$/, "");

export const REFERRAL_BASE = resolveReferralBase();

export const referralApi = (path, options) =>
  adminRequest(REFERRAL_BASE, `/api/admin/referrals${path}`, options);

export async function downloadReferralsCsv(token) {
  try {
    const response = await axios.get(
      `${REFERRAL_BASE}/api/admin/referrals/export`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "text/csv",
        },
      }
    );
    const contentDisposition = response.headers["content-disposition"] || "";
    const filename =
      contentDisposition.match(/filename="?([^";]+)"?/i)?.[1] ||
      `fairsure_referrals_${new Date().toISOString().slice(0, 10)}.csv`;
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    if (axios.isCancel(error)) throw error;

    const status = error.response?.status;
    const responseData = error.response?.data;
    let responseMessage;
    if (responseData instanceof Blob) {
      try {
        const payload = JSON.parse(await responseData.text());
        responseMessage = payload.message || payload.errorMessage;
      } catch {
        responseMessage = undefined;
      }
    } else {
      responseMessage = responseData?.message || responseData?.errorMessage;
    }

    const message =
      status === 401
        ? "Your session has expired. Please sign in again."
        : status === 403
        ? "Access denied. Your account may be suspended; please contact support."
        : !status || status >= 500
        ? "Unable to reach the service. Please try again."
        : responseMessage || "Failed to download the referral report.";
    const failure = new Error(message);
    failure.status = status;
    throw failure;
  }
}
